// store/sectorSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {BASE_URL} from '../commonConfig/ApiConfig'

export const fetchSectors = createAsyncThunk('sector/fetchSectors', async () => {
  const res = await axios.get(`${BASE_URL}sectors`);
  return {
    sectors: res.data.sectors,
    supertags: res.data.supertags,
  };
});

export const fetchSectorById = createAsyncThunk('sector/fetchSectorById', async (id) => {
  const res = await axios.get(`${BASE_URL}sectors/${id}`);
  // return res.data;
  return {
    sectors: res.data.parent,
    supertags: res.data.children,
  };
});

const sectorSlice = createSlice({
  name: 'sector',
  initialState: {
    items: [],
    supertags: [],
    selectedSector: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSectors.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSectors.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.sectors;
        state.supertags = action.payload.supertags;
      })
      .addCase(fetchSectors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchSectorById.pending, (state) => {
        state.loading = true;
        state.selectedSector = null;
      })
      .addCase(fetchSectorById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedSector = action.payload;
      })
      .addCase(fetchSectorById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default sectorSlice.reducer;
